module.exports = __webpack_public_path__ + "img/D202206_2.b9b55aa9.jpg";